module.exports = __webpack_public_path__ + "static/media/logo.ea6c846b.png";